import { Function } from '@phosphor-icons/react';

export default Function;
